@if (mode === 'renderer') {
  <div
    class="dc-card d-flex"
    [class.cursor-pointer]="element.fields.link"
    [class.dp-hover-darken]="element.fields.hoverEffect === 'darken'"
    [class.dp-hover-lighten]="element.fields.hoverEffect === 'lighten'"
    (click)="btnClick($event, element.fields.link)"
    [ngStyle]="{
      'margin-top.px': element.fields.marginTop,
      'margin-right.px': element.fields.marginRight,
      'margin-bottom.px': element.fields.marginBottom,
      'margin-left.px': element.fields.marginLeft,
      'padding-top.px': element.fields.paddingTop,
      'padding-right.px': element.fields.paddingRight,
      'padding-bottom.px': element.fields.paddingBottom,
      'padding-left.px': element.fields.paddingLeft,
      'background-color': element.fields.backgroundColor,
      'min-height.px': element.fields.minHeight,
      'justify-content': element.fields.displayHorizontal,
      'align-items': element.fields.displayVertical,
      'background-image': element.fields.backgroundImage ? 'url(' + element.fields.backgroundImage + ')' : null
    }"
  >
    <div
      class="card-content"
      [ngStyle]="{ 'max-width.px': element.fields.contentMaxWidth ? element.fields.contentMaxWidth : null }"
    >
      <div
        [innerHTML]="
          (element.fields.translate
            ? element.fields.title.i18n?.[currentLang]
            : element.fields.title.value || element.fields.title.value === ''
              ? element.fields.title.value
              : element.fields.title) | safeHtml
        "
      ></div>
      <div
        [innerHTML]="
          (element.fields.translate
            ? element.fields.description.i18n?.[currentLang]
            : element.fields.description.value || element.fields.description.value === ''
              ? element.fields.description.value
              : element.fields.description) | safeHtml
        "
      ></div>
    </div>
  </div>
}

@if (mode === 'editor') {
  <div class="editor">
    <lib-gung-tabset #ngbTab="gungTabset" justify="fill">
      <lib-gung-tab id="content">
        <ng-template libGungTabTitle>
          <div class="tab-title">
            <span>Content</span>
          </div>
        </ng-template>
        <ng-template libGungTabContent>
          <div class="row">
            <div class="col-12">
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [(ngModel)]="element.fields.translate"
                  id="translate"
                  (ngModelChange)="changeTranslate()"
                />
                <label class="form-check-label" for="translate">Translate</label>
              </div>
            </div>
            @if (element.fields.translate) {
              <lib-gung-accordion [closeOthers]="false">
                @for (lang of translateLangs; track lang) {
                  <lib-gung-accordion-item [collapsed]="true">
                    <ng-template libGungAccordionHeader>{{ lang.toUpperCase() }}</ng-template>
                    <ng-template libGungAccordionBody class="acc-body">
                      <div class="col-12 mb-2">
                        <lib-gung-html-editor
                          [gungTranslate]="'TITLE'"
                          [angularEditorConfig]="angularEditorConfig"
                          placeholder="Type the content here!"
                          [(ngModel)]="element.fields.title.i18n[lang]"
                          [backgroundColor]="element.fields.backgroundColor"
                        ></lib-gung-html-editor>
                      </div>
                      <div class="col-12 mb-2">
                        <lib-gung-html-editor
                          [gungTranslate]="'DESCRIPTION'"
                          [angularEditorConfig]="angularEditorConfig"
                          placeholder="Type the content here!"
                          [(ngModel)]="element.fields.description.i18n[lang]"
                          [backgroundColor]="element.fields.backgroundColor"
                        ></lib-gung-html-editor>
                      </div>
                    </ng-template>
                  </lib-gung-accordion-item>
                }
              </lib-gung-accordion>
            } @else {
              <div class="col-12 mb-2">
                @if (element.fields.title.value || element.fields.title.value === '') {
                  <lib-gung-html-editor
                    [gungTranslate]="'TITLE'"
                    [angularEditorConfig]="angularEditorConfig"
                    placeholder="Type the content here!"
                    [(ngModel)]="element.fields.title.value"
                    [backgroundColor]="element.fields.backgroundColor"
                  ></lib-gung-html-editor>
                } @else {
                  <lib-gung-html-editor
                    [gungTranslate]="'TITLE'"
                    [angularEditorConfig]="angularEditorConfig"
                    placeholder="Type the content here!"
                    [(ngModel)]="element.fields.title"
                    [backgroundColor]="element.fields.backgroundColor"
                  ></lib-gung-html-editor>
                }
              </div>
              <div class="col-12 mb-2">
                @if (element.fields.description.value || element.fields.description.value === '') {
                  <lib-gung-html-editor
                    [gungTranslate]="'DESCRIPTION'"
                    [angularEditorConfig]="angularEditorConfig"
                    placeholder="Type the content here!"
                    [(ngModel)]="element.fields.description.value"
                    [backgroundColor]="element.fields.backgroundColor"
                  ></lib-gung-html-editor>
                } @else {
                  <lib-gung-html-editor
                    [gungTranslate]="'DESCRIPTION'"
                    [angularEditorConfig]="angularEditorConfig"
                    placeholder="Type the content here!"
                    [(ngModel)]="element.fields.description"
                    [backgroundColor]="element.fields.backgroundColor"
                  ></lib-gung-html-editor>
                }
              </div>
            }

            

            <div class="col-12 mb-2">
              <div class="d-flex justify-content-between">
                <div class="form-group">
                  <label [for]="idUploadInput">Background Image</label>
                  <input
                    type="text"
                    class="form-control"
                    id="{{ idUploadInput }}"
                    [(ngModel)]="element.fields.backgroundImage"
                  />
                </div>

                <!-- <lib-gung-text-input
                  [gungTranslate]="'Background Image'"
                  [(ngModel)]="element.fields.backgroundImage"
                  inputId=""
                ></lib-gung-text-input> -->
                <div (click)="uploadImage()" class="cursor-pointer upload-image">
                  <i class="fa-solid fa-upload"></i>
                </div>
              </div>
            </div>
            <div class="col-12 mb-2">
              <lib-gung-text-input
                [gungTranslate]="'LINK'"
                [(ngModel)]="element.fields.link"
              ></lib-gung-text-input>
            </div>
            <div class="col-12 mb-2">
              <lib-dynamic-page-element-hover
                [showEffect]="true"
                [(effect)]="element.fields.hoverEffect"
              ></lib-dynamic-page-element-hover>
            </div>
          </div>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab id="styles">
        <ng-template libGungTabTitle>
          <div class="tab-title">
            <span>Styles</span>
          </div>
        </ng-template>
        <ng-template libGungTabContent>
          <lib-gung-accordion #acc="gungAccordion" [closeOthers]="false">
            <lib-gung-accordion-item [collapsed]="true">
              <ng-template libGungAccordionHeader>General Settings</ng-template>
              <ng-template libGungAccordionBody>
                <div class="row">
                  <lib-dynamic-page-element-margin-padding
                    [(marginTop)]="element.fields.marginTop"
                    [(marginRight)]="element.fields.marginRight"
                    [(marginBottom)]="element.fields.marginBottom"
                    [(marginLeft)]="element.fields.marginLeft"
                    [(paddingTop)]="element.fields.paddingTop"
                    [(paddingRight)]="element.fields.paddingRight"
                    [(paddingBottom)]="element.fields.paddingBottom"
                    [(paddingLeft)]="element.fields.paddingLeft"
                  ></lib-dynamic-page-element-margin-padding>

                  <div class="col-12">
                    <lib-gung-number-input
                      [gungTranslate]="'MIN_HEIGHT'"
                      [(ngModel)]="element.fields.minHeight"
                    ></lib-gung-number-input>
                  </div>
                  <div class="col-12">
                    <div class="d-flex color-dp-input">
                      <lib-gung-text-input
                        [gungTranslate]="'BACKGROUND'"
                        [(ngModel)]="element.fields.backgroundColor"
                      ></lib-gung-text-input>
                      <input class="input-color" type="color" [(ngModel)]="element.fields.backgroundColor" />
                    </div>
                  </div>
                  <div class="col-12 mt-2">
                    <lib-gung-select-option-input
                      gungTranslate="Content Position Vertical"
                      [optionsList]="verticalOptions"
                      [(ngModel)]="element.fields.displayVertical"
                    ></lib-gung-select-option-input>
                  </div>
                  <div class="col-12">
                    <lib-gung-select-option-input
                      gungTranslate="Content Position Horizontal"
                      [optionsList]="horizontalOptions"
                      [(ngModel)]="element.fields.displayHorizontal"
                    ></lib-gung-select-option-input>
                  </div>
                  <div class="col-12">
                    <lib-gung-number-input
                      [gungTranslate]="'Content Max Width'"
                      [(ngModel)]="element.fields.contentMaxWidth"
                    ></lib-gung-number-input>
                  </div>
                </div>
              </ng-template>
            </lib-gung-accordion-item>
          </lib-gung-accordion>
        </ng-template>
      </lib-gung-tab>
    </lib-gung-tabset>
  </div>
}

@if (mode === 'preview') {
  <div class="iat-preview">
    <i class="fa-regular fa-image-landscape iat-bg-icon"></i>
    <div class="iat-content">
      <div class="iat-title">Title</div>
      <div class="iat-desc">Lorem ipsum dolor sit amet.</div>
    </div>
  </div>
}
